module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bOvqQ"))).then(() => parcelRequire('1iHdE'));